(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoDeleteController',IntrumentoRelacionadoDeleteController);

    IntrumentoRelacionadoDeleteController.$inject = ['$uibModalInstance', 'entity', 'IntrumentoRelacionado'];

    function IntrumentoRelacionadoDeleteController($uibModalInstance, entity, IntrumentoRelacionado) {
        var vm = this;

        vm.intrumentoRelacionado = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IntrumentoRelacionado.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
